import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/'
)({
  beforeLoad: ctx => {
    throw redirect({
      params: ctx.params,
      replace: true,
      to: '/organizations/$advisoryOrganizationId/plans/$planId/participants'
    });
  }
});
